import { CloudflowEngine, type OperationPointer } from "@doitintl/cmp-models";
import { getCollection } from "@doitintl/models-any";
import { useDocumentData } from "@doitintl/models-hooks";

export const useOperationData = (operationPointer: OperationPointer) => {
  const docRef = getCollection(CloudflowEngine)
    .doc("integrations")
    .collection("apis")
    .doc(operationPointer.provider)
    .collection("services")
    .doc(operationPointer.service)
    .collection("versions")
    .doc(operationPointer.version)
    .collection("operations")
    .doc(operationPointer.id);

  const [operationData, loading, error] = useDocumentData(docRef, {
    caching: true,
    cachingKeys: [
      "cloudflow-operation-descriptor",
      operationPointer.provider,
      operationPointer.service,
      operationPointer.version,
      operationPointer.id,
    ],
  });

  return { operationData, loading, error };
};
